import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import React from 'react'
import styled from 'styled-components'

const ModalBody: React.FC<BoxProps> = ({ children, ...props }) => {
  return <StyledModalBody {...props}>{children}</StyledModalBody>
}

const StyledModalBody = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;

  width: 100%;
  height: 100%;

  overflow-y: auto;

  ::-webkit-scrollbar-track {
    margin: 16px 0;
  }
`
export default ModalBody
